"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModuleResultExtractor = void 0;
var httpHelper_1 = require("./helper/httpHelper");
var siteAssetsClientErrors_1 = require("./domain/siteAssetsClientErrors");
exports.ModuleResultExtractor = function () {
    var moduleResult = function (httpResponse) {
        var contentType = httpResponse.rawHttpResponse.headers.get(httpHelper_1.CONTENT_TYPE_HEADER);
        if (contentType) {
            return contentType.includes(httpHelper_1.JSON_CONTENT_TYPE) ? httpResponse.rawHttpResponse.json() : httpResponse.rawHttpResponse.text();
        }
        return Promise.reject(new siteAssetsClientErrors_1.InvalidServerResponse('server response is missing content-type header'));
    };
    return {
        moduleResult: moduleResult
    };
};
